import { Plane } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 rounded-full bg-[#FF1493] flex items-center justify-center">
            <Plane size={15} strokeWidth={1.5} className="text-black" />
          </span>
          <div>
            <p className="font-display font-black uppercase tracking-tight text-lg">Tanvi Mandapaka</p>
            <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-white/40">Engineering the human future</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
